import Link from 'next/link'
import React from "react"
import Image from 'next/image'

export default function Footer() {
    let currentYear = (new Date).getFullYear();
    return (
        <footer className="text-center text-lg-start footer">
            <div className="container">
                <div className="footer__logos">
                    <div className="footer__site-logo">
                    </div>

                    <div className="ssl">
                        <Image src="/images/ssl1.png" width="60" height="60" alt="ssl protected"/>
                        <Image src="/images/ssl2b.png" width="60" height="60" alt="ssl protected 2"/>
                        <Image src="/images/ssl3.png" width="45" height="45" alt="ssl protected 3"/>
                    </div>
                </div>

                <div className="footer__content">
                    <div className="footer__disclaimer">
                        <p>
                            <span className="text-uppercase">
                                IMPORTANT DISCLAIMERS:
                            </span><br/>
                            irs-extension.com is designated as an Authorized IRS e-file Provider. An Authorized IRS
                            e-file Provider (Provider) is a business or organization authorized by the IRS to
                            participate in the IRS e-file program.
                        </p>
                    </div>

                    <div className="footer__nav">
                        <ul className="footer__nav-links list-unstyled">
                            <li>
                                <Link href="/">
                                    Home
                                </Link>
                            </li>

                            <li>
                                <Link href="/login">
                                    Customer Login
                                </Link>
                            </li>

                            <li>
                                <Link href="/contact-us">
                                    Contact Us
                                </Link>
                            </li>

                            <li>
                                <Link href={"https://blog." + process.env.NEXT_PUBLIC_WEBSITE_HOST}>
                                    Blog
                                </Link>
                            </li>
                        </ul>

                        <ul className="footer__nav-about list-unstyled">
                            <li>
                                <Link href="/faq">
                                    FAQ
                                </Link>
                            </li>

                            <li>
                                <Link href="/terms-of-use">
                                    Terms of Use
                                </Link>
                            </li>

                            <li>
                                <Link href="/privacy-policy">
                                    Privacy Policy
                                </Link>
                            </li>

                            <li>
                                <Link href="/refund-policy">
                                    Refund policy
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="footer__copyright text-center">
                <p>
                ©irs-extension.com. All rights reserved. <br/>
                Method Marketing, LLC d/b/a IRS-Extension.com, d/b/a e.file-tax.net <br/>
                4926 Windy Hill Drive, Suite B Raleigh, NC 27609 (800)630-0780 <br/>
                <a href='https://www.irs.gov/efile-index-taxpros-search?zip=27609&state=All&ero=All&bureau=All&developer=All&transmitter=All&page=3'>Authorized e.file provider</a> <br/>
                We will help you prepare your print & mail extension form for free. The cost of e filing will vary and starts at $29.95 unless otherwise stated.
                </p>

            </div>
        </footer>
    )
}
